import { render } from "./CirculationStatistics.vue?vue&type=template&id=6812daa0&scoped=true"
import script from "./CirculationStatistics.vue?vue&type=script&lang=js"
export * from "./CirculationStatistics.vue?vue&type=script&lang=js"

import "./CirculationStatistics.vue?vue&type=style&index=0&id=6812daa0&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6812daa0"]])

export default __exports__